import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { PageSubmitButton } from 'Views/Page/Components/PageSubmitButton/PageSubmitButton';
import fr from 'facet-rest';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import { buildPageLink } from 'Views/Page/Content/Templates';
import { clientPaths } from 'Consts/Strings';
import { LayoutPaperActions, WizardLayout } from '../Components';

export const Layout = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <WizardLayout
      aboveTitle={pageContentResource.withRelationship(fr.relationships.image.name, (rel) => {
        return (
          <FDStack maxWidth={500} spacing={4} direction={'column'}>
            <ImageRel relationship={rel} width={'100%'} />
          </FDStack>
        );
      }, () => null)}
    >
      <LayoutPaperActions>
        <PageSubmitButton resource={pageContentResource} />
        {pageContentResource.withRelationship(fr.relationships.askMyPlanner.name, (rel) => {
          return (
            <FDPrimaryActionButton
              href={buildPageLink(rel.link('related'), clientPaths.messagesPage, { loadCompose: true })}
              label={rel.meta('prompt')}
            />
          );
        }, () => null)}
      </LayoutPaperActions>
    </WizardLayout>
  );
};
